import { createFileRoute } from '@tanstack/react-router'
import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import { Metadata } from "next";
import { ROUTES } from "@/config/routes";
import React from "react";

export const metadata: Metadata = {
  title: "Next.js Calender | TailAdmin - Next.js Dashboard Template",
  description:
    "This is Next.js Calender page for TailAdmin  Tailwind CSS Admin Dashboard Template",
  // other metadata
};
function page() {
  return (
    <div>
           <PageBreadcrumb items={[
  { label: 'Dashboard', href: ROUTES.ADMIN_DASHBOARD.path },
  { label: 'Line Chart', href: '/line-chart', active: true }
]} />
      
    </div>
  );
}

export const Route = createFileRoute('/(admin)/(others-pages)/calendar/')({
  component: page,
})
